import { Building } from "lucide-react";
import GenericPracticePage from "@/components/GenericPracticePage";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const ConsularProcessing = () => {
  const faqs = [
    {
      question: "What happens at the consular interview?",
      answer: "A consular officer will review your application, verify your documents, ask questions about your relationship (for family-based cases) or employment (for employment-based cases), and determine visa eligibility. Interviews typically last 10-20 minutes. Bring all requested documents in original form.",
    },
    {
      question: "What if I'm denied at the consular interview?",
      answer: "Denials can occur due to inadmissibility issues, insufficient documentation, or credibility concerns. We can help you understand the denial reasons, determine if you're eligible for a waiver, gather additional evidence, or reapply if appropriate. Don't give up - many denials can be overcome.",
    },
  ];

  const mainContent = (
    <>
      <div className="prose prose-lg max-w-none mb-12">
        <h2 className="text-3xl font-bold mb-6">Your Path to a U.S. Visa from Abroad</h2>
        <p className="text-xl text-muted-foreground mb-8">
          Consular processing is a crucial step for individuals seeking to obtain a U.S. green card or immigrant visa while living outside of the United States. If you or a loved one is applying for permanent residency from abroad, our experienced team at Daniel Albert Law Firm can guide you through every step.
        </p>

        <h3 className="text-2xl font-bold mb-4">The Consular Process</h3>
        <ol className="list-decimal pl-6 mb-6">
          <li>Approved immigrant petition (I-130, I-140, etc.)</li>
          <li>National Visa Center (NVC) processing and document submission</li>
          <li>DS-260 immigrant visa application</li>
          <li>Medical examination</li>
          <li>Consular interview at U.S. embassy/consulate</li>
          <li>Visa approval and entry to U.S.</li>
          <li>Receipt of physical green card after entry</li>
        </ol>

        <h3 className="text-2xl font-bold mb-4">Interview Preparation</h3>
        <p className="mb-8">
          The consular interview is critical. We prepare you thoroughly by reviewing likely questions, organizing your documentation, explaining what to expect, identifying potential issues, and providing tips for successful interviews. We're with you every step of the way.
        </p>

        <h3 className="text-2xl font-bold mb-6">Frequently Asked Questions</h3>
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, index) => (
            <AccordionItem key={index} value={`item-${index}`}>
              <AccordionTrigger className="text-left">{faq.question}</AccordionTrigger>
              <AccordionContent className="text-muted-foreground">{faq.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </>
  );

  return (
    <GenericPracticePage
      title="Consular Processing"
      subtitle="Immigrant visa processing through U.S. embassies and consulates abroad"
      icon={<Building className="h-20 w-20 mx-auto mb-6 text-accent" />}
      mainContent={mainContent}
    />
  );
};

export default ConsularProcessing;
